// extracted by mini-css-extract-plugin
export var cartContainer = "_hh-4";
export var gray = "_hh-1";
export var itemContainer = "_hh-2";
export var itemDetails = "_hh-3";
export var strong = "_hh-0";